<template>
  <v-card class="tn-booking__head">
    <div class="tn-booking__head-main">
      <span class="tn-booking__icon" :class="'tn-booking__icon--' + type"><v-icon size="26">{{ icon }}</v-icon></span>
      <div class="tn-booking__head-text">
        <div class="tn-booking__title-row">
          <h2 class="tn-booking__title">Booking #{{ booking.id }}</h2>
          <v-chip v-if="booking.status" small label class="tn-status-chip" :class="'tn-status-chip--' + statusColor(booking.status)">{{ statusLabel(booking.status) }}</v-chip>
          <v-chip v-for="tag in tags.filter(Boolean)" :key="tag" small label outlined class="tn-booking__supplier">{{ tag }}</v-chip>
        </div>
        <div class="tn-booking__subtitle">{{ title }}</div>
        <div class="tn-booking__meta">Created {{ dateTime(booking.created_at) }}</div>
      </div>
    </div>
    <div class="tn-booking__head-side">
      <div class="tn-booking__total-label">{{ totalLabel }}</div>
      <div class="tn-booking__total">{{ total === null || total === undefined || total === '' ? '—' : money(total) }}</div>
      <slot name="actions"></slot>
    </div>
  </v-card>
</template>

<script>
import { formatDate, formatMoney, statusColor, statusLabel } from '../../utils/format'

export default {
  name: 'BookingSummary',
  props: {
    booking: { type: Object, required: true },
    type: { type: String, default: 'packages' },
    icon: { type: String, default: 'mdi-ticket-confirmation-outline' },
    title: { type: String, default: '' },
    tags: { type: Array, default: () => [] },
    total: { type: [Number, String], default: null },
    totalLabel: { type: String, default: 'Booking total' }
  },
  methods: {
    statusColor,
    statusLabel,
    money (value) {
      return formatMoney(value)
    },
    dateTime (value) {
      return formatDate(value, true)
    }
  }
}
</script>
